import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common components
import { Form, Button, TextInput } from "src/Components";
// Types
import { ISellOrBuyQueueConfig } from "src/Interfaces/automaticMarketMaking";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import { addComma, removeComma } from "src/helper";
// Requests
import {
  getBuyQueueConfig,
  setBuyQueueConfig,
  getSellQueueConfig,
  setSellQueueConfig,
} from "src/Requests/automaticMarketMaking";

interface Props {
  type: "buy" | "sell";
  onSuccess: () => void;
  onClose: () => void;
}
const SellOrBuyQueueConfigModal: React.FC<Props> = (props) => {
  // local store
  const [config, setConfig] = React.useState({} as ISellOrBuyQueueConfig);

  const getData = () =>
    props.type === "buy" ? getBuyQueueConfig() : getSellQueueConfig();

  const setData = () =>
    props.type === "buy"
      ? setBuyQueueConfig(config)
      : setSellQueueConfig(config);

  React.useEffect(() => {
    getData()
      .then((res) => {
        setConfig(res);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setConfig({ ...config, [name]: value });
  };

  const clickHandler = () => {
    setData()
      .then((resp) => {
        toast.success(resp.msg);
        props.onSuccess();
        props.onClose();
      })
      .catch(packetErrorHandler);
  };

  const changePriceHandler = (name: string, value: string) => {
    setConfig({ ...config, [name]: removeComma(value) });
  };

  return (
    <>
      <Form className="!w-80 gap-3 py-8 px-2 !mx-auto">
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">حدبالای ضریب</span>
          <TextInput
            label=""
            name="upperboundfactor"
            onChange={changeHandler}
            value={config?.upperboundfactor?.toString() || ""}
            kind="percent"
            extraLabel
          />
        </div>
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72"> حد پایین ضریب</span>
          <TextInput
            label=""
            name="lowerboundfactor"
            onChange={changeHandler}
            value={config?.lowerboundfactor?.toString() || ""}
            kind="percent"
            extraLabel
          />
        </div>
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">
            حداقل ارزش صف {props.type === "buy" ? "خرید" : "فروش"}
          </span>
          <TextInput
            label=""
            name="minAmount"
            onChange={changePriceHandler}
            value={addComma(config?.minAmount ?? 0)}
            extraLabel
          />
        </div>
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">
            حداکثر ارزش صف {props.type === "buy" ? "خرید" : "فروش"}
          </span>
          <TextInput
            label=""
            name="maxAmount"
            onChange={changePriceHandler}
            value={addComma(config?.maxAmount ?? 0)}
            extraLabel
          />
        </div>
      </Form>
      <div className="mt-6 mx-10">
        <Button text="ثبت" onClick={clickHandler} variant="contained" />
      </div>
    </>
  );
};

export default SellOrBuyQueueConfigModal;
